import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class StatusEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {string} */
		this.key = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
	}

	/**
	 * @typedef {Object} _StatusEditDtoProps
	 * @property {string} key
	 * @property {string} value
	 * @typedef {import("../NamedDto").NamedDtoProps & _StatusEditDtoProps} StatusEditDtoProps
	 */
	/**
	 *
	 * @param {StatusEditDtoProps} props
	 * @returns {StatusEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.key = props.key;
		this.value = props.value;
		return this;
	}
}

export default StatusEditDto;
